import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanalCommunication } from 'src/app/shared/models/canalCommunication';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class CanalCommunicationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllCanalCommunication(): Observable<CanalCommunication[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.canalCommunicationUrl}/all`,
			'getAllCanalCommunication'
		);
	}

	importCanalCommunication(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'canalCommunication.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.canalCommunicationUrl}/import`,
			`importCanalCommunication`,
			formData
		);
	}

	getCanalCommunicationById(id: number): Observable<CanalCommunication> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.canalCommunicationUrl}/get/${id}`,
			'getCanalCommunicationById'
		);
	}

	updateCanalCommunication(canalCommunication: CanalCommunication): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.canalCommunicationUrl}/update/${canalCommunication.id}`,
			'updateCanalCommunication',
			canalCommunication
		);
	}

	addCanalCommunication(canalCommunication: CanalCommunication): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.canalCommunicationUrl}/add`,
			'addCanalCommunication',
			canalCommunication
		);
	}

	deleteCanalCommunication(canalCommunicationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.canalCommunicationUrl}/delete/${canalCommunicationId}`,
			`deleteCanalCommunication`
		);
	}
}
